<div class="status-page">
  <app-ticket-get-status-default></app-ticket-get-status-default>
</div>
